/**
 * Get the utmSource and utmMedium parameters from the URL params
 * @returns {{utmSource: string, utmMedium: string}}
 */
function getUtmData() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmContent = urlParams.get('utm_content');
    const gclid = urlParams.get('gclid');
    const svCampaignId = urlParams.get('sv_campaign_id');
    const sn = urlParams.get('sn');

    return { utmSource, utmMedium, utmCampaign, utmContent, gclid, svCampaignId, sn };
}

/**
 * When the page loads we check if there are some utm parameters in the URL
 * If so, we save them on local storage
 */
function initAwinTracking() {
    let { utmSource, utmMedium, utmCampaign, utmContent, gclid, svCampaignId, sn } = getUtmData();

    // If no UTM source/medium, apply fallback defaults
    const noTrackingParams = !utmSource && !utmMedium;

    // Last touchpoint and publisher params always update, when tracking param given
    if (!noTrackingParams) {
        sessionStorage.setItem('utm_last_touchpoint', `${String(utmMedium)}-${String(utmSource)}`);
    }

    const noPublisherParams = !svCampaignId && !sn;
    if (!noPublisherParams) {
        sessionStorage.setItem('sv_campaign_id', svCampaignId);
        sessionStorage.setItem('sn', sn);
    }

    if (noTrackingParams && document.referrer === 'https://www.google.com/') {
        utmSource = 'google';
        utmMedium = 'organic';

        if (sessionStorage.getItem('utm_last_touchpoint') === null) {
            sessionStorage.setItem('utm_last_touchpoint', `${String(utmMedium)}-${String(utmSource)}`);
        }
    }

    // Only set UTM values if they're not already in sessionStorage
    const hasExistingUtm = sessionStorage.getItem('utm_source') || sessionStorage.getItem('utm_medium') || sessionStorage.getItem('gclid');

    if (!hasExistingUtm) {
        const utmParams = {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            gclid: gclid
        };

        for (const key in utmParams) {
            if (Object.hasOwnProperty.call(utmParams, key) && utmParams[key]) {
                sessionStorage.setItem(key, utmParams[key]);
            }
        }
    }
}

initAwinTracking();

define("skr/tracking/awinTracking", function(){});

